/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Add_Font_DescInputs */

const en_options_fonts_add_font_desc = /** @type {(inputs: Options_Fonts_Add_Font_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add system fonts to use in your captions and subtitles`)
};

const fr_options_fonts_add_font_desc = /** @type {(inputs: Options_Fonts_Add_Font_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter des polices système à utiliser dans vos sous-titres`)
};

const de_options_fonts_add_font_desc = /** @type {(inputs: Options_Fonts_Add_Font_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie Systemschriftarten hinzu, die Sie in Ihren Untertiteln verwenden möchten.`)
};

const it_options_fonts_add_font_desc = /** @type {(inputs: Options_Fonts_Add_Font_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi i font di sistema da utilizzare nei sottotitoli`)
};

const ru_options_fonts_add_font_desc = /** @type {(inputs: Options_Fonts_Add_Font_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавьте системные шрифты для использования в субтитрах и подписях.`)
};

const es_options_fonts_add_font_desc = /** @type {(inputs: Options_Fonts_Add_Font_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregue fuentes del sistema para usar en sus subtítulos y leyendas`)
};

const zh_cn2_options_fonts_add_font_desc = /** @type {(inputs: Options_Fonts_Add_Font_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加系统字体以用于字幕和副标题`)
};

const ja_options_fonts_add_font_desc = /** @type {(inputs: Options_Fonts_Add_Font_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションや字幕に使用するシステムフォントを追加する`)
};

const hi_options_fonts_add_font_desc = /** @type {(inputs: Options_Fonts_Add_Font_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने कैप्शन और सबटाइटल में उपयोग करने के लिए सिस्टम फ़ॉन्ट जोड़ें`)
};

const pt_pt2_options_fonts_add_font_desc = /** @type {(inputs: Options_Fonts_Add_Font_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione fontes do sistema para usar em suas legendas e subtítulos.`)
};

/**
* | output |
* | --- |
* | "Add system fonts to use in your captions and subtitles" |
*
* @param {Options_Fonts_Add_Font_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_add_font_desc = /** @type {((inputs?: Options_Fonts_Add_Font_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Add_Font_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_fonts_add_font_desc(inputs)
	if (locale === "de") return de_options_fonts_add_font_desc(inputs)
	if (locale === "it") return it_options_fonts_add_font_desc(inputs)
	if (locale === "ru") return ru_options_fonts_add_font_desc(inputs)
	if (locale === "es") return es_options_fonts_add_font_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_fonts_add_font_desc(inputs)
	if (locale === "ja") return ja_options_fonts_add_font_desc(inputs)
	if (locale === "hi") return hi_options_fonts_add_font_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_fonts_add_font_desc(inputs)
	return en_options_fonts_add_font_desc(inputs)
});